import Slider from "react-slick";
import DateCell from "./DateCell";
import { MonthData } from "@/src/types/monthData";
import { CalendarDate } from "@/src/types/calendarDay";

interface Props {
  dateSliderRef: any;
  allMonths: MonthData[];
  currentYear: number;
  dateSliderSettings: any;
  isDateSelected: (day: CalendarDate) => boolean;
  handleDateSelect: (day: CalendarDate) => void;
}

export default function CalendarGrid({
  allMonths,
  currentYear,
  dateSliderRef,
  dateSliderSettings,
  handleDateSelect,
  isDateSelected,
}: Props) {
  const weekdays = ["CN", "Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy"];

  return (
    //DESKTOP
    <div key={currentYear} className="bg-white overflow-hidden">
      <div className="grid grid-cols-7 border-b">
        {weekdays.map((day, i) => (
          <div
            key={day}
            className={`h-12 flex items-center justify-center font-medium text-sm border-r last:border-r-0
            ${
              i === 0
                ? "text-red-500"
                : i === 6
                ? "text-orange-500"
                : "text-gray-700"
            }
          `}
          >
            {day}
          </div>
        ))}
      </div>

      <Slider ref={dateSliderRef} {...dateSliderSettings}>
        {allMonths.map((month) => (
          <div key={`month-${month.year}-${month.month}`} className="relative">
            <div className="w-full grid grid-cols-7">
              {month.days.map((day) => (
                <div
                  key={`day-${day.year}-${day.month}-${day.day}`}
                  className="p-2 border-r border-b last:border-r-0 flex items-center justify-center"
                >
                  <DateCell
                    day={day}
                    handleDateSelect={handleDateSelect}
                    isSelected={isDateSelected(day)}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
